<template>
  <div class="w-full min-h-screen flex flex-col">
    <MainNav />
    <section class="w-full relative">
      <!-- Hero Image -->
      <img 
        src="/image/83islands_sugarcane.jpg" 
        alt="83 Islands Sugarcane Field" 
        class="w-full h-[600px] object-cover object-center"
      />
      
      <!-- Text Overlay -->
      <div class="mx-auto absolute mt-36 inset-0 z-20 w-full p-4 lg:p-36 flex flex-col items-center lg:items-start pointer-events-none">
        <h1 class="text-white font-maax text-4xl uppercase lg:text-6xl font-bold text-center lg:text-left max-w-3xl leading-tight drop-shadow-[0_5px_5px_rgba(0,0,0,0.3)] pointer-events-auto">
          Join the 83 Islands Operator Program
        </h1>
      </div>

      <!-- Double Wave -->
      <div class="absolute -bottom-1 left-0 right-0 w-full overflow-hidden">
        <svg viewBox="0 0 1200 120" preserveAspectRatio="none" class="w-full h-20 text-white">
          <path d="M985.66,92.83C906.67,72,823.78,31,743.84,14.19c-82.26-17.34-168.06-16.33-250.45.39-57.84,11.73-114,31.07-172,41.86A600.21,600.21,0,0,1,0,27.35V120H1200V95.8C1132.19,118.92,1055.71,111.31,985.66,92.83Z" 
                fill="currentColor" class="opacity-25"/>
          <path d="M985.66,92.83C906.67,72,823.78,31,743.84,14.19c-82.26-17.34-168.06-16.33-250.45.39-57.84,11.73-114,31.07-172,41.86A600.21,600.21,0,0,1,0,27.35V120H1200V95.8C1132.19,118.92,1055.71,111.31,985.66,92.83Z" 
                fill="currentColor"/>
        </svg>
      </div>
    </section>

    <main class="flex-grow w-full bg-white py-16">
      <div class="container mx-auto px-4">
        <div class="max-w-2xl mx-auto text-center">
          <h2 class="text-3xl font-maax font-bold uppercase text-black mb-6">
            Partner with 83 Islands
          </h2>
          <p class="font-maax text-black text-xl mb-12">
            83 Islands is a leader in Guest experience in Port Vila. Join our Tour Operator Program to have access to better deals for you and your clients, check our schedule, request after-hours tours or private events.
          </p>
        </div>

        <!-- Registration Form -->
        <div class="max-w-md mx-auto bg-white p-8 rounded-lg shadow-lg border border-gray-100">
          <h3 class="text-2xl font-maax font-semibold text-black text-center mb-6">Request Access</h3>
          <form @submit.prevent="submitRequest">
            <div class="mb-4">
              <label for="companyName" class="block text-sm/6 font-medium text-gray-900">Company Name</label>
              <div class="mt-2">
                <input 
                  type="text" 
                  id="companyName" 
                  v-model="companyNameInput" 
                  required 
                  class="block w-full rounded-md bg-white px-3 py-1.5 text-gray-900 border border-gray-300 placeholder:text-gray-400 focus:outline-2 focus:-outline-offset-2 focus:outline-indigo-600 sm:text-sm/6"
                />
              </div>
            </div>
            <div class="mb-4">
              <label for="contactName" class="block text-sm/6 font-medium text-gray-900">Contact Name</label>
              <div class="mt-2">
                <input 
                  type="text" 
                  id="contactName" 
                  v-model="contactNameInput" 
                  required 
                  class="block w-full rounded-md bg-white px-3 py-1.5 text-gray-900 border border-gray-300 placeholder:text-gray-400 focus:outline-2 focus:-outline-offset-2 focus:outline-indigo-600 sm:text-sm/6"
                />
              </div>
            </div>
            <div class="mb-4">
              <label for="email" class="block text-sm/6 font-medium text-gray-900">Email Address</label>
              <div class="mt-2">
                <input 
                  type="email" 
                  id="email" 
                  v-model="emailInput" 
                  required 
                  class="block w-full rounded-md bg-white px-3 py-1.5 text-gray-900 border border-gray-300 placeholder:text-gray-400 focus:outline-2 focus:-outline-offset-2 focus:outline-indigo-600 sm:text-sm/6"
                  placeholder="you@example.com"
                />
              </div>
            </div>
            <div class="mb-4">
              <label for="mobilePhone" class="block text-sm/6 font-medium text-gray-900">Mobile Phone Number</label>
              <div class="mt-2">
                <input 
                  type="tel" 
                  id="mobilePhone" 
                  v-model="mobilePhoneInput" 
                  required 
                  class="block w-full rounded-md bg-white px-3 py-1.5 text-gray-900 border border-gray-300 placeholder:text-gray-400 focus:outline-2 focus:-outline-offset-2 focus:outline-indigo-600 sm:text-sm/6"
                />
              </div>
            </div>
            <div class="mb-4">
              <label for="operatorType" class="block text-sm/6 font-medium text-gray-900">Type of Operator</label>
              <div class="mt-2">
                <select 
                  id="operatorType" 
                  v-model="operatorTypeInput" 
                  required
                  class="block w-full rounded-md bg-white px-3 py-1.5 text-gray-900 border border-gray-300 focus:outline-2 focus:-outline-offset-2 focus:outline-indigo-600 sm:text-sm/6"
                >
                  <option disabled value="">Please select</option>
                  <option>Freelance Taxi and Bus Drivers</option>
                  <option>Private Guides</option>
                  <option>Half-Day or Full-Day Excursion Providers</option>
                  <option>Cruise Shore Excursion Specialists</option>
                  <option>Large Coach Operators</option>
                  <option>Eco and Adventure Tours</option>
                  <option>Other</option>
                </select>
              </div>
            </div>
            <div class="mb-4">
              <label for="tourFrequency" class="block text-sm/6 font-medium text-gray-900">Frequency of Tours</label>
              <div class="mt-2">
                <select 
                  id="tourFrequency" 
                  v-model="tourFrequencyInput" 
                  required
                  class="block w-full rounded-md bg-white px-3 py-1.5 text-gray-900 border border-gray-300 focus:outline-2 focus:-outline-offset-2 focus:outline-indigo-600 sm:text-sm/6"
                >
                  <option disabled value="">Please select</option>
                  <option>Only on cruise ship days</option>
                  <option>Once a week</option>
                  <option>A few times a week</option>
                  <option>Every day</option>
                  <option>Irregularly/On demand</option>
                </select>
              </div>
            </div>
            <div class="mb-4">
              <label for="chargingModel" class="block text-sm/6 font-medium text-gray-900">How are guests charged for activities?</label>
              <div class="mt-2">
                <select 
                  id="chargingModel" 
                  v-model="chargingModelInput" 
                  required
                  class="block w-full rounded-md bg-white px-3 py-1.5 text-gray-900 border border-gray-300 focus:outline-2 focus:-outline-offset-2 focus:outline-indigo-600 sm:text-sm/6"
                >
                  <option disabled value="">Please select</option>
                  <option value="operator_charges">I charge my guests directly for activities</option>
                  <option value="guest_pays">My guests pay for activities on-site</option>
                </select>
              </div>
            </div>
            <div class="mb-6">
              <label for="waitsOnSite" class="block text-sm/6 font-medium text-gray-900">Do you wait for your guests on site?</label>
              <div class="mt-2">
                <select 
                  id="waitsOnSite" 
                  v-model="waitsOnSiteInput" 
                  required
                  class="block w-full rounded-md bg-white px-3 py-1.5 text-gray-900 border border-gray-300 focus:outline-2 focus:-outline-offset-2 focus:outline-indigo-600 sm:text-sm/6"
                >
                  <option disabled value="">Please select</option>
                  <option value="yes">Yes, I wait for my guests on site</option>
                  <option value="no">No, I do not wait for my guests on site</option>
                </select>
              </div>
            </div>

            <!-- Honeypot Field -->
            <div style="position:absolute; left: -5000px;" aria-hidden="true">
              <label for="website_url">Do not fill this if you are human</label>
              <input type="text" id="website_url" name="website_url" v-model="websiteUrlInput" tabindex="-1" autocomplete="off">
            </div>

            <button 
              type="submit" 
              :disabled="isSubmitting" 
              class="w-full flex justify-center py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-cyan-600 hover:bg-cyan-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-cyan-500 disabled:opacity-50"
            >
              {{ isSubmitting ? 'Submitting...' : 'Request Invite' }}
            </button>
          </form>
          <p v-if="submitMessage" class="mt-4 text-center text-sm" :class="submitStatus === 'success' ? 'text-green-600' : 'text-red-600'">
            {{ submitMessage }}
          </p>
        </div>
      </div>
    </main>
    <Footer class="relative" />
  </div>
</template>

<script setup>
import { ref } from 'vue';
import MainNav from '../components/MainNav.vue';
import Footer from '../components/Footer.vue';

const companyNameInput = ref('');
const contactNameInput = ref('');
const emailInput = ref('');
const mobilePhoneInput = ref('');
const operatorTypeInput = ref('');
const tourFrequencyInput = ref('');
const chargingModelInput = ref('');
const waitsOnSiteInput = ref('');
const websiteUrlInput = ref(''); // Honeypot field

const isSubmitting = ref(false);
const submitMessage = ref('');
const submitStatus = ref(''); // 'success' or 'error'

const submitRequest = async () => {
  isSubmitting.value = true;
  submitMessage.value = '';
  submitStatus.value = '';

  // Honeypot check
  if (websiteUrlInput.value) {
    console.warn('Honeypot field filled, likely a bot.');
    // You can choose to silently fail or give a generic error
    submitMessage.value = 'Submission failed. Please try again.'; 
    submitStatus.value = 'error';
    isSubmitting.value = false;
    return;
  }

  // Basic validation (more robust validation can be added)
  if (!companyNameInput.value || !contactNameInput.value || !emailInput.value || !mobilePhoneInput.value || !operatorTypeInput.value || !tourFrequencyInput.value || !chargingModelInput.value || !waitsOnSiteInput.value) {
    submitMessage.value = 'Please fill in all fields.';
    submitStatus.value = 'error';
    isSubmitting.value = false;
    return;
  }

  console.log('Requesting invite for:', companyNameInput.value, contactNameInput.value, emailInput.value, mobilePhoneInput.value, operatorTypeInput.value, tourFrequencyInput.value, chargingModelInput.value, waitsOnSiteInput.value, websiteUrlInput.value);

  // TODO: Implement actual API call to backend to handle the request
  try {
    // Replace with your actual API endpoint and logic
    const response = await fetch('/api/touroperators', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ 
        companyName: companyNameInput.value, 
        contactName: contactNameInput.value,
        email: emailInput.value,
        mobilePhone: mobilePhoneInput.value,
        operatorType: operatorTypeInput.value,
        tourFrequency: tourFrequencyInput.value,
        chargingModel: chargingModelInput.value,
        waitsOnSite: waitsOnSiteInput.value,
        website_url: websiteUrlInput.value // Send honeypot field
      })
    });

    if (!response.ok) {
      const errorData = await response.json().catch(() => ({ message: 'An unknown error occurred.' }));
      throw new Error(errorData.message || `HTTP error! status: ${response.status}`);
    }

    // const responseData = await response.json(); // If your backend sends back data

    submitMessage.value = 'Request submitted successfully! We will contact you shortly.';
    submitStatus.value = 'success';
    companyNameInput.value = ''; // Clear form on success
    contactNameInput.value = '';
    emailInput.value = '';
    mobilePhoneInput.value = '';
    operatorTypeInput.value = '';
    tourFrequencyInput.value = '';
    chargingModelInput.value = '';
    waitsOnSiteInput.value = '';
    websiteUrlInput.value = ''; // Clear honeypot field

  } catch (error) {
    console.error('Error submitting request:', error);
    submitMessage.value = 'An error occurred. Please try again later.';
    submitStatus.value = 'error';
  } finally {
    isSubmitting.value = false;
  }
};
</script>
